import { render, staticRenderFns } from "./GetMessagesVoice.vue?vue&type=template&id=0863f988&"
import script from "./GetMessagesVoice.vue?vue&type=script&lang=js&"
export * from "./GetMessagesVoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports